import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=33f8de0f&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f8de0f')) {
      api.createRecord('33f8de0f', component.options)
    } else {
      api.reload('33f8de0f', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=33f8de0f&", function () {
      api.rerender('33f8de0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/FavElement.vue"
export default component.exports